<form [formGroup]="gurukulaSevaForm" (ngSubmit)="onSubmit()">
    <div class="step-container">
      <ng-template #labelGurukulaSeva>Gurukula Seva</ng-template>
      <div class="step-title">Gurukula Seva Questions</div>
  {{gurukulaSevaForm.value | json}}
      <!-- Question 1 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputGurukulaStudent">1. At this time in your life, why do you feel that being a gurukula student, offering full-time seva in Gurudev Siddha Peeth, is the best way for you to serve the Siddha Yoga mission?</label>
          <textarea
            class="form-control"
            id="inputGurukulaStudent"
            formControlName="gurukulaStudent"
            rows="3"
            placeholder="Share your thoughts"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && gurukulaSevaForm.get('gurukulaStudent')?.invalid" class="text-danger">
            <div *ngIf="gurukulaSevaForm.get('gurukulaStudent')?.errors?.['required']">This field is required.</div>
            <div *ngIf="gurukulaSevaForm.get('gurukulaStudent')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="gurukulaSevaForm.get('gurukulaStudent')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 2 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputSevaQualities">2. In performing seva, which qualities do you feel are your strongest? In what ways have you applied them while serving in your local centre? What qualities would you like to develop or continue to develop, while offering seva in Gurudev Siddha Peeth?</label>
          <textarea
            class="form-control"
            id="inputSevaQualities"
            formControlName="sevaQualities"
            rows="3"
            placeholder="Describe your qualities and areas of growth"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && gurukulaSevaForm.get('sevaQualities')?.invalid" class="text-danger">
            <div *ngIf="gurukulaSevaForm.get('sevaQualities')?.errors?.['required']">This field is required.</div>
            <div *ngIf="gurukulaSevaForm.get('sevaQualities')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="gurukulaSevaForm.get('sevaQualities')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 3 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputSevaPlans">3. What are your plans to resume your life when you return from the gurukula after your seva term is complete? Do you have resources required for that?</label>
          <textarea
            class="form-control"
            id="inputSevaPlans"
            formControlName="sevaPlans"
            rows="3"
            placeholder="Share your post-seva plans"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && gurukulaSevaForm.get('sevaPlans')?.invalid" class="text-danger">
            <div *ngIf="gurukulaSevaForm.get('sevaPlans')?.errors?.['required']">This field is required.</div>
            <div *ngIf="gurukulaSevaForm.get('sevaPlans')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="gurukulaSevaForm.get('sevaPlans')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 4 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputAshramContribution">4. In what specific ways will you contribute to the sacred environment of the ashram as a long-term gurukula student?</label>
          <textarea
            class="form-control"
            id="inputAshramContribution"
            formControlName="ashramContribution"
            rows="3"
            placeholder="Describe your planned contributions"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && gurukulaSevaForm.get('ashramContribution')?.invalid" class="text-danger">
            <div *ngIf="gurukulaSevaForm.get('ashramContribution')?.errors?.['required']">This field is required.</div>
            <div *ngIf="gurukulaSevaForm.get('ashramContribution')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="gurukulaSevaForm.get('ashramContribution')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Buttons -->
      <div class="d-flex justify-content-between">
        <div>
          <button class="btn savedraftbtn" type="button">SAVE AS DRAFT</button>
        </div>
        <div>
          <button type="button" class="prevbtn" (click)="goToBack()">PREVIOUS</button>
          <button type="submit" class="nextbtn">NEXT</button>
        </div>
      </div>
    </div>
  </form>
  